
import { BadgeType, BadgeId } from "@/app/@types";
import { supabase } from "../supabase-client";

export const awardBadge = async (
  userId: string,
  badgeId: BadgeId
): Promise<BadgeType> => {
  try {
    if (!userId) {
      throw new Error('User ID is required');
    }
    if (!badgeId) {
      throw new Error('Badge ID is required');
    }

    const { data: existingBadge, error: checkError } = await supabase
      .from("badges")
      .select("*")
      .eq("user_id", userId)
      .eq("badge_id", badgeId);

    if (checkError) {
      console.error("Error checking existing badge:", checkError);
      throw new Error(`Database error while checking existing badge: ${checkError.message}`);
    }

    if (existingBadge && existingBadge.length > 0) {
      console.log(`Badge ${badgeId} already awarded to user ${userId}`);
      return existingBadge[0] as BadgeType;
    }


    const newBadge: BadgeType = {
      id: crypto.randomUUID(),
      user_id: userId,
      badge_id: badgeId,
      earned_at: new Date().toISOString(),
      minted: false,
      minted_at: null,
      tx_hash: null,
    };

    const { data, error } = await supabase
      .from("badges")
      .insert(newBadge)
      .select()
      .single();

    if (error) {
      console.error("Error awarding badge:", error);
      throw new Error(`Database error while awarding badge: ${error.message}`);
    }

    if (!data) {
      throw new Error('Badge was not created successfully');
    }

    console.log(`Successfully awarded badge ${badgeId} to user ${userId}`);
    return data;
    
  } catch (error) {
    console.error("Failed to award badge:", error);
    
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error('Unexpected error occurred while awarding badge');
    }
  }
};